import React from 'react';
import './App.css';
import Header from './components/header/Header';
import Home from './pages/home/Home';


function App() {
  return (
    <div>
      <Header />
      <Home />
    </div>
  )
}

export default App
